<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden auth-screen">

  <!-- Background Hero Layers -->
  <div class="auth-hero-bg position-absolute top-0 start-0 w-100 h-100"></div>
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           LOGIN (Glass Card Style)
      =========================== -->
      <div class="
          glass-card glass-card-neon p-4 p-md-5 rounded-4 shadow-sm col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto">

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class=" mb-1 text-center text-white">
          Welcome Back
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Login to continue exploring insights.
        </p>

        <!-- =========================
             ERROR MESSAGE
        =========================== -->
        <SnackbarMessage
          :error-message="error_message"
          :success-message="success_message"
          @dismiss-error="error_message = ''"
          @dismiss-success="success_message = ''"
        />

        <!-- =========================
             LOADING STATE
        =========================== -->
        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white-50">Authenticating...</span>
        </div>

        <!-- =========================
             LOGIN FORM
        =========================== -->
        <form @submit.prevent="handle_login" v-if="!is_loading">

          <!-- Email -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">Email</label>
            <input
              v-model="credentials.email"
              type="email"
              class="form-control form-control-sm rounded-3
                    bg-transparent text-white border-secondary placeholder-white"
              placeholder="Enter email"
              required
            />

          </div>

          <!-- Password -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50 mb-1">Password</label>
            <div class="position-relative">
              <input
                v-model="credentials.password"
                :type="password_input_type"
                class="form-control form-control-sm rounded-3 pe-5
                      bg-transparent text-white border-secondary placeholder-white"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                class="btn position-absolute top-50 end-0 translate-middle-y text-white-50 px-2"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>

          </div>

          <!-- Login Button -->
          <button
            class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3"
            :disabled="is_loading"
          >
            Login
          </button>

          <!-- Forgot Password -->
          <p class="text-center text-white-50 text-xs mb-0">
            Forgot your password?
            <router-link
              to="/reset_password"
              class="text-decoration-none text-primary"
            >
              Reset
            </router-link>
          </p>

        </form>
      </div>

    </div>
  </div>
</div>
